module.exports = __webpack_public_path__ + "img/controller.3ee52200.svg";